export function* write(socket: SocketIOClient.Socket) {
  // while (true) {
  //   const { payload } = yield take(`${sendMessage}`);
  //   socket.emit("message", payload);
  // }
}
